/**
 * Core types for the Legendary Arena game engine.
 *
 * LegendaryGameState is the shape of boardgame.io game state (G).
 * MatchConfiguration is the match setup payload passed to Game.setup().
 *
 * Zone and player state types are defined canonically in
 * src/state/zones.types.ts and re-exported here for backward compatibility.
 */
export { PERSISTENCE_CLASSES } from './persistence/persistence.types.js';
export { REVEALED_CARD_TYPES } from './villainDeck/villainDeck.types.js';
// why: WP-513 / D-24325 — Killbots' "number of Twists next to this Scheme" counter
// key (G.counters). Seeded 3 at setup, +1 per Killbots twist; a Killbot's attack
// equals this value. A plain counter key (not an endgame condition).
/** G.counters key for Killbots' "twists next to this Scheme" (drives Killbot attack). */
export const KILLBOT_TWISTS_NEXT_TO_SCHEME = 'killbotTwistsNextToScheme';
// why: WP-823 / D-24756 — Brainwash the Military's "Traitor Battalion", the Twists
// stacked next to the Scheme. Never seeded (reads `?? 0`), +1 per Twist 1-6; an
// Officer's Attack is 3 plus this value, and the twist resolver numbers each Twist
// from it (the stack position, which schemeTwistCount does not track). A plain counter.
/** G.counters key for Brainwash the Military's Traitor Battalion (Twists stacked next to the Scheme). */
export const TRAITOR_BATTALION_TWISTS = 'traitorBattalionTwists';
// why: WP-539 / D-24348 — Portals-specific counter, one per Dark Portal placed
// (mirrors KILLBOT_TWISTS_NEXT_TO_SCHEME). Twist 1 places the Mastermind portal;
// twists 2-6 place city-space portals; twist 7 is Evil Wins. Drives BOTH the
// mastermind attack bonus (+1 once >= 1) and the positional villain bonus (+1 to a
// villain whose city space has been portal'd). A plain G.counters key.
/** G.counters key for Portals' Dark Portal count (drives the Dark-Portal attack buffs). */
export const DARK_PORTAL_COUNT = 'darkPortalCount';
export { ENDGAME_CONDITIONS } from './endgame/endgame.types.js';
export { VP_VILLAIN, VP_HENCHMAN, VP_BYSTANDER, VP_TACTIC, VP_WOUND, } from './scoring/scoring.types.js';
export { PENALTY_EVENT_TYPES } from './scoring/parScoring.types.js';
export { VILLAIN_ABILITY_TIMINGS, VILLAIN_EFFECT_KEYWORDS, VILLAIN_DEFEAT_REQUIREMENT_KINDS, } from './rules/villainAbility.types.js';
export { EFFECT_EXECUTION_REASONS, isHollowReason, HOLLOW_EFFECTS_CAP, DEFERRED_BY_DESIGN_MECHANICS, } from './diagnostics/hollowEffect.types.js';
export { NOTABLE_EVENT_TYPES, SCHEME_TWIST_RESOLVER_KEYS, } from './events/notableEvents.types.js';
export { BOARD_KEYWORDS } from './board/boardKeywords.types.js';
export { SCHEME_SETUP_TYPES } from './scheme/schemeSetup.types.js';
export { INVARIANT_CATEGORIES } from './invariants/invariants.types.js';
//# sourceMappingURL=types.js.map